"use client";

import GlassCard from "../glass-card";
import { env } from "@/lib/env";
import ProjectCard from "./project-card";
import { useProjects } from "@/hooks/use-projects";

export default function ProjectsShowcase() {
  const { projects, loading, error, refetch } = useProjects({
  username: env.NEXT_PUBLIC_GITHUB_USERNAME,
  maxProjects: 6,
});

const cleanProjects = projects?.filter(
  (project) => project.name !== "oluoko"
);

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <GlassCard
            key={i}
            variant="tinted"
            blur="lg"
            glow="medium"
            className="p-6 animate-pulse"
          >
            <div className="aspect-video bg-primary/10 rounded-lg mb-4" />
            <div className="h-6 bg-primary/10 rounded mb-2" />
            <div className="h-20 bg-primary/10 rounded mb-4" />
            <div className="flex gap-2">
              <div className="h-6 w-16 bg-primary/10 rounded" />
              <div className="h-6 w-16 bg-primary/10 rounded" />
            </div>
          </GlassCard>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {cleanProjects.map((project) => (
        <ProjectCard project={project} key={project.id} />
      ))}
    </div>
  );
}
